import { ChangeEvent } from 'react';
import styled from 'styled-components';
import { cBC44FF, cFFFFFF } from '#/colors';

interface Props {
  readonly id?: string;
  readonly disabled?: boolean;
  readonly checked: boolean;
  readonly onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export default function Toggle(props: Props) {
  const { id, disabled, checked, onChange } = props;

  return (
    <Container checked={checked} disabled={disabled}>
      <CheckboxInput
        id={id}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      <ToggleKnob aria-hidden checked={checked} />
    </Container>
  );
}

const Container = styled.span<{ checked: boolean; disabled?: boolean }>`
  height: 18px;
  width: 36px;
  border-radius: 11px;
  background-color: #1f1f3a;
  cursor: pointer;
  ${({ disabled }) => disabled != null && `opacity: ${disabled ? 0.7 : 1}`};
  ${({ checked }) => checked && `background-color: ${cBC44FF}`};

  input {
    cursor: pointer;
  }
`;

const CheckboxInput = styled((props) => <input type="checkbox" {...props} />)`
  opacity: 0;
  position: absolute;
`;

const ToggleKnob = styled.span<{ checked: boolean }>`
  display: block;
  height: 18px;
  width: 18px;
  border-radius: 11px;
  background-color: ${cFFFFFF};

  ${({ checked }) => checked && `float: right`};
`;
